/* Current HDPP Tooltip (OLD) */

import React, { useRef, forwardRef } from 'react';
import classNames from 'classnames';
import {
  oneOf, string
} from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import '../../tooltip.scss';
import { buildImageURL } from '../../../utils/product-add-on-utils';
import { ICONS } from '../../../utils/product-add-on-constants';

export const CurrentProtectionPlanTooltip = forwardRef(({
  channel,
  url,
}, buttonRef) => {

  const toolTipLabelClasses = classNames({
    'u__default-link': true,
    'product-add-on-tooltip-content__label': true,
    scrollTouch: channel === 'mobile',
  });
  const logo = 'https://assets.homedepot-static.com/p/static/images/hdpp_logo_2.png';
  const tooltip = (
    <div className="product-add-on-tooltip-content" data-channel={`${channel}`}>
      <div className="product-add-on-tooltip-content__header">The Home Depot Protection Plan</div>
      <div className="product-add-on-tooltip-content__body">

        <p>
          Protect your purchase and enjoy the plan benefits of:
        </p>

        <ul className="product-add-on-tooltip-content__list">
          <li>24/7 support</li>
          <li>No deductibles, no additional fees</li>
          <li>Parts and labor costs included</li>
          <li>Transferable coverage and more</li>
        </ul>
        <div className="product-add-on-tooltip-content__hdpp-section">
          <p>
            Rest easy that your product is covered.  The plan begins once your manufacturer&apos;s warranty ends.
          </p>
          <p>
            Your Protection Plan documents will be emailed to you within 2 days of purchase.
            <br />
            <a
              href={url}
              target="_blank"
              className="u__default-link"
              rel="noopener noreferrer"
            >
              Plan Details
            </a>
          </p>
        </div>

        <p className="product-add-on-tooltip-content__logo">
          <img
            className="product-add-on-tooltip-content__logo__img-styling"
            src={logo}
            alt=""
            aria-hidden="true"
          />
        </p>
      </div>
    </div>
  );

  return (
    <Tooltip channel={channel} placement="bottom" content={tooltip} closeButton>
      <button ref={buttonRef} type="button" className={toolTipLabelClasses}>
        What&apos;s Included
        <img
          src={buildImageURL(ICONS.info)}
          alt="information tooltip"
          className="product-add-on-tooltip-content__label__suffix"
        />
      </button>
    </Tooltip>
  );
});

CurrentProtectionPlanTooltip.displayName = 'ProductAddOns-HdppTooltip';

CurrentProtectionPlanTooltip.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
  /** toolTipContentHeading -> Renders as Heading for tooltip content */
  url: string.isRequired
};

CurrentProtectionPlanTooltip.defaultProps = {
  channel: oneOf(['desktop', 'mobile']),
};